import { Stack } from '@mantine/core'
import { forwardRef, useImperativeHandle, useRef } from 'react'

import type { CMFormSection } from '@/screens/ContentModuleFormScreen/ContentModuleFormScreen'
import { FAQSection, type FAQSectionRef } from '@/screens/ContentModuleFormScreen/FAQSection'
import { ResourcesTable } from '@/screens/ContentModuleFormScreen/ResourcesTable'

export interface OptionalSettingsSectionRef {
  saveFAQs: () => Promise<void>
}

export const OptionalSettingsSection = forwardRef<OptionalSettingsSectionRef, CMFormSection>((props, ref) => {
  const faqSectionRef = useRef<FAQSectionRef>(null)

  useImperativeHandle(
    ref,
    () => ({
      saveFAQs: async () => {
        await faqSectionRef.current?.saveUnsavedFAQs()
      },
    }),
    [],
  )
  return (
    <Stack gap="xxxl">
      {/* <Radio.Group
        label={<ComingSoon prefix="Privacy Setting " />}
        description="Select a setting for the whole module. You can select a different setting on a section-by-section basis."
        inputWrapperOrder={['label', 'description', 'input', 'error']}
        {...props.form.getInputProps('access')}
        onChange={e => {
          props.form.setFieldValue('access', e as z.infer<UseContentModuleFormSchema>['access'])
          // updateCM(['access'])() // NOT IMPLEMENTED
        }}>
        <Group gap="xl" align="stretch">
          <RadioCard
            value={props.schema.shape.access.enum.open}
            label="Open"
            description="The user's Sidekick can sit in on the user's conversation about this module."
          />

          <RadioCard
            value={props.schema.shape.access.enum.restricted}
            label="Restricted"
            description="The module contains proprietary and confidential information."
          />
        </Group>
      </Radio.Group> */}

      <FAQSection {...props} type="cm" ref={faqSectionRef} />

      <ResourcesTable {...props} type="cm" />
    </Stack>
  )
})

OptionalSettingsSection.displayName = 'OptionalSettingsSection'
